export default {
    GuideprepaUrl: "https://drive.google.com/file/d/1coj562HzSPf545_A_7Q8u0-C3yDbMv9D/view"
};
